import React, { useEffect, useState } from "react";
import {ReactComponent as Telegram} from '../images/Telegram.svg'
import {ReactComponent as Instagram} from '../images/instagram.svg'
import {ReactComponent as Link} from '../images/Link.svg'
import {ReactComponent as Gmail} from '../images/Gmail.svg'
import {ReactComponent as Linkedin} from '../images/Linkedin.svg'
import {ReactComponent as Github} from '../images/Github.svg'







const Contacts = () => {
    const handleClick = () => {
        window.location.href = 'https://t.me/zhanibekovye'
    };
  
    const InstaClick = () => {
      window.location.href = 'https://www.instagram.com/_zhan1bekov_/'
    }


    const InClick = () => {
      window.location.href = 'https://www.linkedin.com/in/yelaman-zhanibekov-3935a6303/'
    }

    const GitClick = () => {
      window.location.href = 'https://github.com/zhanibekov'
    }
    
    
    const [textCopy, setTextCopy] = useState('');

    useEffect(() => {
      setTextCopy('elamanzhanibekov@gmail.com')
    });

    const DavidCopperfield = () => {
      if(textCopy) {
        navigator.clipboard.writeText(textCopy)
        .then(() => {
          alert('Copied')
        })
        .catch(err => {
          console.warn('Error')
        })
      }
    }
    return (
     <>
             <div className="Contacts">
                    <h1>Contacts</h1>
             </div>
             <div className="Telega" onClick={handleClick}>
                <Telegram className="Telegram" />
                 <a  className="word" href="https://t.me/zhanibekovye" class="contact-link1">Telegram</a>
                <Link className="t-link" />
             </div>

             <div className="Insta" onClick={InstaClick}>
                <Instagram className="insta-ico"/>
                <a className="insta-word" href="https://www.instagram.com/_zhan1bekov_/">Instagram</a>
                <Link className="insta-link" />
             </div>

             <div className="Linkedin" onClick={InClick}>
                <Linkedin className="linkedin-ico" />
                <a  href="https://www.linkedin.com/in/yelaman-zhanibekov-3935a6303/" className="linkedin-text" >Linkedin</a>
                <Link className="linkedin-link" />
             </div>

            
             <div className="Github" >
                <Github className="github-ico" />
                <a  href="https://github.com/zhanibekov" className="github-text" >Github</a>
                <Link className="github-link" />
             </div>

             
             <div className="Gmail">
                <Gmail className="gmail-ico" />
                <div className="text-box" id={"text-to-copy"}>elamanzhanibekov@gmail.com</div>
                <button className="copy-button" onClick={DavidCopperfield} >Copy!</button>
             </div>
                


     </>
    )
}
export default Contacts